import {
  GetCoursesForAdminPanelDocument,
  useRemoveCourseFromSchoolMutation,
} from "../../../generated/graphql";

export const useRemoveCourse = (schoolId) => {
  const [removeCourseFromSchoolMutation] = useRemoveCourseFromSchoolMutation({
    refetchQueries: [
      {
        query: GetCoursesForAdminPanelDocument,
        variables: { schoolId },
      },
    ],
    errorPolicy: "all",
  });
  return (schoolId, courseId) =>
    removeCourseFromSchoolMutation({
      variables: {
        schoolId,
        courseId,
      },
    });
};
